import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Redirect, useLocation } from 'react-router';
import Footer from '../Footer';
import Header from '../Header';
import Modal from '../Modal';
import Seo from '../Seo/Seo';
import { PropsFromRedux } from '.';
import ShippingFormProvider from '../../context/ShippingFormContext/ShippingFormProvider';
import OverseasShippingFormProvider from '../../context/OverseasShippingFormContext/ShippingFormProvider';
import ErrorBoundary from '../ErrorBoundary';

interface Props extends PropsFromRedux {
  component: React.ReactNode;
  requiresAuth?: boolean;
  requiresNoAuth?: boolean;
}

const Layout: React.FC<Props> = ({
  component,
  auth,
  clear,
  notification,
  requiresAuth,
  requiresNoAuth,
}) => {
  const isLoggedIn = auth?.success && auth?.response;
  const isActive = auth?.response?.Object?.IsActive;
  const location = useLocation();

  // const [scroll, setScroll] = useState(false)
  const [showMenu, setShowMenu] = React.useState<boolean>(false)
  // console.log("show menu layout-- ", showMenu)

  React.useEffect(() => {
    if (notification.alertType && notification.message) {
      toast[notification.alertType](notification.message, {
        position: 'top-right',
        onClose: clear,
      });
    }
  }, [clear, notification.alertType, notification.message]);

  const toggleShowMenu = () => setShowMenu(!showMenu)

  if (requiresAuth && !isLoggedIn) {
    return <Redirect to="/sign-in" />;
  }

  if (
    requiresAuth &&
    isLoggedIn &&
    !isActive &&
    location.pathname !== '/verify-otp'
  ) {
    return <Redirect to="/verify-otp" />;
  }

  if (requiresNoAuth && isLoggedIn) {
    return <Redirect to="/" />;
  }

  return (
    <ErrorBoundary>
    <OverseasShippingFormProvider>
      <ShippingFormProvider>
        <Seo title="" description="" />
        <Modal />

        <div className={`${showMenu ? "h-screen min-h-0 overflow-y-hidden " : "flex font-serif min-h-full flex-col items-stretch w-full"}`}>
          <Header showMenu={showMenu} setShowMenu={setShowMenu} 
            toggleShowMenu={toggleShowMenu} 
          />
          {/* <main className="flex w-screen h-screen overflow-y-auto flex-col bg-gray-100 "> */}
          <main className="flex w-full h-screen  flex-col bg-gray-100 ">
            <ToastContainer className="font-medium text-sm z-50" />
            <div className="flex w-full h-auto bg-gray-100 flex-shrink-0 flex-grow">
              {component}
            </div>
            <Footer />
          </main>
          {/* <Footer /> */}
        </div>
      </ShippingFormProvider>
    </OverseasShippingFormProvider>
    </ErrorBoundary>
  );
};

export default Layout;
